<template>
    <div v-if="show" class="toast-wrap">
        <div class="toast-mask"></div>
        <div class="toast__icon" v-if="!!icon">
            <div class="row center v-center" style="height:60px;">
                <div class="icon-56">
                    <i class="iconfont" :class="iconName" style="font-size:64px;"></i>
                </div>
            </div>
            <p class="content">{{ message }}</p>
        </div>
        <div class="toast" v-else>
            <p class="content">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            icon: '',
            message: '',
        };
    },
    computed: {
        iconName() {
            return `icon-${this.icon}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/modules/all';

.toast-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5000;
}
.toast__icon {
    position: fixed;
    z-index: 5001;
    width: 100px;
    min-height: 100px;
    top: 50%;
    left: 50%;
    background: rgba(17, 17, 17, 0.7);
    text-align: center;
    border-radius: 5px;
    color: #ffffff;
    transform: translate(-50%, -50%);
}
.toast {
    position: fixed;
    z-index: 5000;
    top: 50%;
    left: 50%;
    padding: 6px 12px;
    // background: rgba(17, 17, 17, 0.7);
    text-align: center;
    border-radius: 5px;
    color: #ffffff;
    transform: translate(-50%, -50%);
}
.toast .content {
    margin: 0;
    font-size: 14px;
}

//
//
//
.fade-enter-active .toast-mask,
.fade-leave-active .toast-mask {
    will-change: transform;
    transition: all 0.3s ease;
}
.fade-enter-active .toast,
.fade-leave-active .toast {
    will-change: transform;
    transition: all 0.3s ease;
}

.fade-enter .toast-mask {
    opacity: 0;
}
.fade-enter .toast {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
}

.fade-enter-to .toast-mask {
    opacity: 1;
}
.fade-enter-to .toast {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

.fade-leave .toast-mask {
    opacity: 1;
}
.fade-leave .toast {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

.fade-leave-to .toast-mask {
    opacity: 0;
}
.fade-leave-to .toast {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
}

// .toast {
//     background-color: $ElevatedPrimarySystemGroupedBackground;
//     color: $DarkPrimaryLabelColor;
// }
// @media screen and (prefers-color-scheme: dark) {
//     .toast {
//         background-color: $ElevatedTertiarySystemGroupedBackground;
//         color: $DarkPrimaryLabelColor;
//     }
// }
</style>
